<mat-stepper [selectedIndex]="selectedIndex" (selectionChange)="selectedIndex = $event.selectedIndex">
    <mat-step [ngClass]="{'selected-step': selectedIndex === 1}">
        <ng-template matStepLabel>Día</ng-template>
        <app-column-chart-activity-system [data]="dataWeekDay" [changeSystem]='changeSystem'
            nameRoot="weekDay"></app-column-chart-activity-system>
    </mat-step>
    <mat-step [ngClass]="{'selected-step': selectedIndex === 1}">
        <ng-template matStepLabel>Mes</ng-template>
        <app-column-chart-activity-system [data]="dataMonth" [rangeWeek]="false" [changeSystem]='changeSystem'
            nameRoot="month"></app-column-chart-activity-system>
    </mat-step>
</mat-stepper>
